import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config || {};
    const skip = NO_REFRESH.some((p) => (cfg.url || "").includes(p));
    if (error.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  if (typeof detail?.message === "string") {
    const list = (detail.conflicts || []).map((c) => `${c.rider_name}: ${c.pickup} → ${c.dropoff} (${c.status}, ${new Date(c.scheduled_at).toLocaleString()})`);
    return [detail.message, ...list].join(" · ");
  }
  return String(detail);
}
